import { Toaster as Sonner } from 'sonner'
import type { ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
	return (
		<Sonner
			theme='dark'
			className='toaster group'
			style={
				{
					'--normal-bg': 'var(--sidebar)',
					'--normal-text': 'var(--sidebar-foreground)',
					'--normal-border': 'var(--sidebar-border)',
				} as React.CSSProperties
			}
			// Messages that carry a multi-line body (e.g. a resource's dependency list) keep their
			// line breaks; single-line toasts are unaffected.
			toastOptions={{ classNames: { title: 'whitespace-pre-line', description: 'whitespace-pre-line' } }}
			{...props}
		/>
	)
}

export { Toaster }
